export function clickWithFocus(fn: (...args: any[]) => any) {
  return {
    tabIndex: 0,
    onClick: fn,
    onKeyDown: (e) => {
      if (e.key === 'Enter') {
        fn(e);
      }
    },
  };
}
